module.exports = __webpack_public_path__ + "img/banner.a2b19c58.png";